export enum CommunicationTemplateType {
  SMS = "SMS",
  EMAIL = "EMAIL",
  MAIL = "MAIL",
}

export enum FeatureTemplate {
  WORKSHOP = "workshop",
  CANDIDATE_DASHBOARD = "candidateDashboard",
  CANDIDATE_APPLY = "candidateApply",
  FUP = "fup",
  SOCIAL_OFFER = "socialOffer",
  ACTION = "action",
}
